import React from "react";
import "../../Default.css";
import "./Phrasebook.css";
import type { SubsectionItems } from "./PhraseType";
import phrases_file from "./phrases.json";
import ZoomableImage from "../../components_ui/zoomable-image/ZoomableImage";
import ZoomableImageType from "../../components_ui/zoomable-image/zoomableImageType";
const phrases: SubsectionItems[] = phrases_file as any;

//               <img style={{width: '100%'}} src="/images/linie_metra.png" alt="linie metra"/>
const subwayLineDiagram: ZoomableImageType = {
  src: "/images/linie_metra.png",
  alt: "schemat linii metra",
  copyright: undefined,
  originalWidth: 3000,
  originalHeight: 2122,
};

function Transport() {
  return (
    <>
      <div className="page-title">Transport publiczny w Lizbonie</div>
      <div className="boxes-contener">
        <div className="copyright-tekst">
          tekst zaczerpnięty z przewodnika ŚDM
        </div>
        <div className="text">
          <div className="text-box-header">Zapamiętaj</div>
          <div style={{ margin: "auto" }}>
            {phrases.map((item, index) => (
              <div className="phrase" key={index}>
                <div className="untranslated" style={{ fontSize: "16px" }}>
                  {item.untranslated}
                </div>
                <div className="translated" style={{ fontSize: "16px" }}>
                  {item.translated}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-box">
          <div className="paragraf">
            Najpopularniejszym i najczęściej wybieranym środkiem transportu jest
            lizbońckie metro. Szybkie, tanie i wygodne obejmuje większość miasta
            i jego okolic i nieustannie jest rozbudowywane. Składa się z
            czterech linii, a kadej z nich przyporządkowany jest kolor i symbol.
          </div>
          <img
            style={{ width: "100%" }}
            src="/images/symbole_linii_metra.png"
            alt="kolory i symbole linii metra"
          />
        </div>
        <div className="text-box">
          <div className="paragraf">
            Nie można zapomnieć o tramwajach, które w Lizboonie są nie tylko
            środkiem transportu, ale także atrakcją turystyczną. Istnieje kilka
            linii, z których najsławniejsza jest linia nr 28 biegnąca
            malowniczymi uliczkami miasta. Dobrą ofertę połączeń mają także
            autobusy, któr docierają w miejsca nieosiągalne dla metra czy
            tramwaju.
          </div>
          <ZoomableImage image={subwayLineDiagram} />
          <a href="https://www.metrolisboa.pt/en/">oficjalna strona metra</a>
        </div>
      </div>
    </>
  );
}

export default Transport;
